import {Footer} from '../../components';

function Appointments() {
  return (
    <div>
      <Footer />
    </div>
  )
}

export default Appointments